import { css, SerializedStyles } from '@emotion/core';
import theme from '../../styles/theme';
import { rem } from '../../styles/theme/layout';

const wrapper: SerializedStyles = css`
  text-align: center;
  font-style: italic;
  font-size: ${theme.fontSizes[1]};
  max-width: ${rem(930)};
  margin: 0 auto;
  line-height: 1.6;
`;

const title: SerializedStyles = css`
  margin: 0;
`;

const body: SerializedStyles = css`
  margin: 0;
  /**
  <strong /> is used like a heading element in Typo3 editor 😑.
  This is a work-around to keep consistency between legacy pages and the new front-end.
  TODO: consider to change this when the new CMS will be used.
  */
  strong {
    margin: 0;
    text-align: center;
    display: block;
    font-family: ${theme.fonts.fontBold};
    font-weight: normal;
    letter-spacing: ${theme.typography.headlineLetterSpacing};
  }
  a {
    text-decoration: underline;
  }
`;

export default {
  wrapper,
  title,
  body,
};
